import React, { useEffect, useState } from 'react'
import {
  LoaderWrapper,
  MuiMultiSelect,
  ReportHeading,
  ReportOuterWrapper
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import {
  useUpdateLhs,
  useReactQuery,
  useConditionalQuery
} from '../../../../hooks'
import BuyerTable from '../segmentComparison/buyerTable'
import RelativeBrands from '../segmentOverview/relativeBrands'
// import { SegmentProgression} from './components'
import {
  ContentWrap,
  Divider,
  RootWrap,
  SegmentOfSegmentWrap,
  DropdownWrapper
} from './style'
import { exportExcel_addPercentage, getObjectAsArray, trimFunc, getDistinctValues } from '../../../../util'
import GraphGridTab, { Table } from '../comparisonViewDeepDiveNew/graphGridTab'
import { IconGraphBtn, IconListBtn } from '../../../../assets/images/icons'
import {
  GRAPH_COLOR_PALLET_V2,
  GRAPH_COLOR_PALLET_V2_TEXT
} from '../../../../constants'
import { ProgressionWrapper as ProgressWrapper } from '../reportCustomTable/style'
import { useGlobalStore } from '../../../../store'
import ProgressionBuyerTable from '../reportSegmentProgression/progressionBuyerTable'
import PrismTopContent from '../reportPrism/prismTopContent'

const ReportSegmentAndSegmentOfSegmentV2 = (props) => {
  const [graphPieData, setGraphPieData] = useState([])
  const [state, setState] = useState([])
  const [segmentExcelData, setSegmentExcelData] = useState([])
  const [reportExcelData, setReportExcelData] = useState([])
  const [eventCount, setEventCount] = useState(1)
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [show, setShow] = useState('graph')
  const [checkBoxData, setCheckboxData] = useState([])
  const [segmentData, setSegmentData] = useState([])
  const [showComparison, setShowComparison] = useState('graph')
  const [maxValue, setMaxValue] = useState(0)
  const [allValuesShow, setAllValuesShow] = useState(true)
  const [segmentValues, setSegmentValues] = useState([])
  const [filterValue, setFilterValues] = useState([])
  const [pptData, setPptData] = useState()
  const [finalPptData, setFinalPptData] = useState(null)
  const [isTitleOrdered, setTitleOrderedArray] = useState([])
  const [colorPalletPieArray, setColorPalletPieArray] = useState([])
  const [sortedPieColorObject, setSortedPieColorObject] = useState({})

  const { isPPTModalActive } = useGlobalStore()

  const COLOR_ARRAY_NEW = [
    ...GRAPH_COLOR_PALLET_V2,
    ...GRAPH_COLOR_PALLET_V2_TEXT,
    ...GRAPH_COLOR_PALLET_V2,
    ...GRAPH_COLOR_PALLET_V2_TEXT
  ]

  const onBtnClick = (activeTab) => {
    setShow(activeTab)
  }

  const onCompareBtnClick = (activeTab) => {
    setShowComparison(activeTab)
  }

  const filterChangeFunc = (selectedValue) => {
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false)

    const selectedValues = selectedValue.filter((val) => val !== 'All')

    let data = state?.map((elem) => {
      return {
        ...elem,
        SecondarySegmentSet: {
          ...elem.SecondarySegmentSet,
          SecondarySegment: getObjectAsArray(
            elem?.SecondarySegmentSet?.SecondarySegment
          ).map((obj) => ({
            ...obj,
            SegmentName: String(obj.SegmentName),
            show: selectedValues.includes(obj.SegmentName)
          }))
        }
      }
    })

    console.log('check0=1==========', data)

    setState(data)
    setFilterValues(selectedValue)
  }

  const filterSegmentChangeFunc = (selectedValue) => {
    setAllValuesShow(prev => selectedValue.length > 0 ? true : false)

    const selectedValues = selectedValue.filter((val) => val !== 'All')

    let data = state?.map((elem) => {
      return {
        ...elem,
        SegmentName: String(elem.PrimarySegmentName),
        show: selectedValues.includes(elem.PrimarySegmentName)
      }
    })

    console.log('check0=2==========', data)

    setState(data)
    setSegmentValues(selectedValue)
  }

  const useReactQueryObject2 = {
    payloadDetails: {
      queryId: [
        props.InsightsElementType,
        props.InsightsElementId,
        'PieGraph'
      ],
      urlFunc: ReportsService.getSegmentOverviewElement,
      payload: {
        insightsElementId: props.InsightsElementId
      }
    },
    queryDetails: {
      enabled: false
    }
  }

  const {
    data: data2,
    isLoading: isLoading2,
    isSuccess: isSuccess2,
    isError: isError2,
    error: error2,
    refetch: refetch2
  } = useConditionalQuery(
    useReactQueryObject2,
    {
      ...props,
      serverData: props?.serverData?.pie
    }
  )

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: [
        props.InsightsElementType,
        props.InsightsElementId,
        'BarGraph'
      ],
      urlFunc: ReportsService.getSegmentOfSegmentOverviewElement,
      payload: {
        insightsElementId: props.InsightsElementId
      }
    }
  }

  const {
    data: data1,
    isLoading: isLoading1,
    isSuccess: isSuccess1,
    isError: isError1,
    error: error1,
    refetch: refetch1
  } = useConditionalQuery(
    useReactQueryObject1,
    {
      ...props,
      serverData: props?.serverData?.table
    }
  )

  /*
   * ============================================================
   * COLOR SYNCHRONIZATION
   * ============================================================
   *
   * There were previously two different places updating colors:
   *
   * 1. graphPieData effect -> color
   * 2. updatingStateForColors() -> clr
   *
   * Those two updates could run with different/stale versions of state
   * and overwrite each other.
   *
   * We now create ONE color map and apply the SAME color to both
   * `color` and `clr`.
   */
  useEffect(() => {
    if (!Array.isArray(state) || state.length === 0) {
      return
    }

    const colorMap = {}

    /*
     * First priority:
     * use colors already calculated for graphPieData.
     *
     * graphPieData is already sorted by value in onSuccessFunc2,
     * so its color assignment is the intended priority order.
     */
    if (Array.isArray(graphPieData) && graphPieData.length > 0) {
      graphPieData.forEach((item, index) => {
        const normalizedName = trimFunc(String(item?.name ?? ''))

        if (
          normalizedName &&
          item?.color !== null &&
          item?.color !== undefined &&
          item?.color !== ''
        ) {
          colorMap[normalizedName] = item.color
        } else if (normalizedName && COLOR_ARRAY_NEW[index]) {
          colorMap[normalizedName] = COLOR_ARRAY_NEW[index]
        }
      })
    }

    /*
     * Collect every segment from state.
     *
     * Do not depend on InsightsElementId here. Some API responses
     * do not contain that property on every record.
     */
    const uniqueSegmentNames = []

    state.forEach((period) => {
      const segments = getObjectAsArray(
        period?.SecondarySegmentSet?.SecondarySegment || []
      )

      segments.forEach((segment) => {
        const normalizedName = trimFunc(String(segment?.SegmentName ?? ''))

        if (
          normalizedName &&
          !uniqueSegmentNames.includes(normalizedName)
        ) {
          uniqueSegmentNames.push(normalizedName)
        }
      })
    })

    /*
     * Assign fallback colors to segments that are not present
     * in the pie response.
     *
     * This is important for scenarios where:
     *
     * - a segment has 0 value
     * - the pie API doesn't return it
     * - bar/table API still contains it
     */
    let nextColorIndex = 0

    uniqueSegmentNames.forEach((segmentName) => {
      if (colorMap[segmentName]) {
        return
      }

      /*
       * Skip colors that are already being used.
       */
      while (
        nextColorIndex < COLOR_ARRAY_NEW.length &&
        Object.values(colorMap).includes(COLOR_ARRAY_NEW[nextColorIndex])
      ) {
        nextColorIndex++
      }

      /*
       * Use a deterministic fallback even when there are more
       * segments than colors in the palette.
       */
      const fallbackColor =
        COLOR_ARRAY_NEW[nextColorIndex] ||
        COLOR_ARRAY_NEW[
          nextColorIndex % Math.max(COLOR_ARRAY_NEW.length, 1)
        ]

      if (fallbackColor) {
        colorMap[segmentName] = fallbackColor
      }

      nextColorIndex++
    })

    /*
     * Keep the sorted color object available to the child components.
     */
    setSortedPieColorObject(prev => {
      const prevKeys = Object.keys(prev || {})
      const nextKeys = Object.keys(colorMap)

      if (
        prevKeys.length === nextKeys.length &&
        nextKeys.every(key => prev[key] === colorMap[key])
      ) {
        return prev
      }

      return colorMap
    })

    /*
     * Apply both `color` and `clr` from exactly the same map.
     *
     * This guarantees that they can never disagree or be populated
     * by two separate effects.
     */
    setState(prevState => {
      let hasChanges = false

      const updatedState = prevState.map((elem) => {
        const currentSegments = getObjectAsArray(
          elem?.SecondarySegmentSet?.SecondarySegment || []
        )

        let segmentChanged = false

        const updatedSegments = currentSegments.map((segment) => {
          const normalizedName = trimFunc(
            String(segment?.SegmentName ?? '')
          )

          const mappedColor = colorMap[normalizedName]

          /*
           * Never replace a valid existing color with undefined/null.
           */
          if (
            mappedColor &&
            (
              segment?.color !== mappedColor ||
              segment?.clr !== mappedColor
            )
          ) {
            segmentChanged = true

            return {
              ...segment,
              color: mappedColor,
              clr: mappedColor
            }
          }

          return segment
        })

        if (segmentChanged) {
          hasChanges = true

          return {
            ...elem,
            SecondarySegmentSet: {
              ...elem.SecondarySegmentSet,
              SecondarySegment: updatedSegments
            }
          }
        }

        return elem
      })

      return hasChanges ? updatedState : prevState
    })
  }, [state, graphPieData])

  /*
   * Compute segment excel data.
   *
   * Color handling has intentionally been removed from this effect.
   * Colors now have one dedicated synchronization path above.
   */
  useEffect(() => {
    if (!graphPieData) return

    if (!!state && !!graphPieData) {
      const segmentExcelDataObj = []

      for (let i = 0; i < graphPieData.length; i++) {
        if (!['REMAINING_VALUE'].includes(graphPieData[i].name)) {
          segmentExcelDataObj.push([
            { value: 'Overall' },
            { value: graphPieData[i].name },
            exportExcel_addPercentage(graphPieData[i].value)
          ])
        }
      }

      if (state && state.length) {
        for (let i = 0; i < state.length; i++) {
          const segmentSet = Array.isArray(
            state[i]?.SecondarySegmentSet?.SecondarySegment
          )
            ? state[i].SecondarySegmentSet.SecondarySegment
            : [state[i].SecondarySegmentSet.SecondarySegment]

          for (let j = 0; j < segmentSet.length; j++) {
            if (
              ![
                state[i].PrimarySegmentName,
                segmentSet[j].SegmentName
              ].includes('REMAINING_VALUE')
            ) {
              segmentExcelDataObj.push([
                { value: state[i].PrimarySegmentName },
                { value: segmentSet[j].SegmentName },
                exportExcel_addPercentage(segmentSet[j].SegmentValue)
              ])
            }
          }
        }
      }

      setSegmentExcelData([
        ...segmentExcelData,
        ...segmentExcelDataObj
      ])
    }
  }, [graphPieData, state])

  useEffect(() => {
    filterChangeFunc(checkBoxData)
  }, [checkBoxData])

  useEffect(() => {
    filterSegmentChangeFunc(segmentData)
  }, [segmentData])

  const onSuccessFunc1 = (resp) => {
    const loadTab1Func = (paramData) => {
      let segmentLength = 0

      const getHighestLengthSegment = {
        length: 0,
        index: 0,
        data: [],
        object: {}
      }

      // ===== LOOP 1: Build the longest segment template =====
      for (let i = 0; i < paramData.length; i++) {
        const segs =
          paramData[i]?.SecondarySegmentSet?.SecondarySegment

        if (
          Array.isArray(segs) &&
          segs.length > getHighestLengthSegment.length
        ) {
          getHighestLengthSegment.length = segs.length

          const segmentArr = segs.map(e => ({
            SegmentName: e.SegmentName,
            SegmentValue: ''
          }))

          getHighestLengthSegment.data = segmentArr

          const template = {}

          segmentArr.forEach(s => {
            template[s.SegmentName] = 0
          })

          getHighestLengthSegment.object = template
        }
      }

      // ===== LOOP 2: Apply template to each object =====
      for (let j = 0; j < paramData.length; j++) {
        const record = paramData[j]

        const segmentArray = getObjectAsArray(
          record?.SecondarySegmentSet?.SecondarySegment
        )

        if (
          Array.isArray(segmentArray) &&
          segmentArray.length > 0
        ) {
          const objData = JSON.parse(
            JSON.stringify(getHighestLengthSegment.object)
          )

          segmentArray.forEach(s => {
            objData[s.SegmentName] = s.SegmentValue
          })

          const finalArr = Object.keys(objData).map(name => ({
            SegmentName: name,
            SegmentValue: objData[name]
          }))

          record.SecondarySegmentSet.SecondarySegment = finalArr
        }
      }

      let data = paramData?.map((elem) => {
        return {
          ...elem,
          show: true,
          PeriodName: elem.PrimarySegmentName,
          SecondarySegmentSet: {
            ...elem.SecondarySegmentSet,
            SecondarySegment: getObjectAsArray(
              elem?.SecondarySegmentSet?.SecondarySegment
            ).map((obj, i) => ({
              ...obj,
              SegmentName: String(obj.SegmentName),
              segmentIndex: i,
              show: true
            }))
          }
        }
      })

      if (
        ['SegmentAndSegmentProgression'].includes(
          props.InsightsElementType
        )
      ) {
        setPptData(prev => ({
          ...prev,
          progressionContent: data
        }))
      } else {
        setPptData(prev => ({
          ...prev,
          tableContent: data
        }))
      }

      console.log('check0=4==========', data)

      setState(data)

      const segmentNames = getObjectAsArray(
        paramData[0]?.SecondarySegmentSet?.SecondarySegment
      ).map(i => String(i.SegmentName))

      setCheckboxData(segmentNames)

      const periodNames = paramData.map(
        i => String(i.PrimarySegmentName)
      )

      setSegmentData(periodNames)

      const reportExcelDataObj = []

      for (let i = 0; i < paramData.length; i++) {
        const segmentSet = getObjectAsArray(
          paramData[i]?.SecondarySegmentSet?.SecondarySegment || []
        )

        for (let j = 0; j < segmentSet.length; j++) {
          reportExcelDataObj.push([
            { value: paramData[i].PrimarySegmentName },
            { value: segmentSet[j].SegmentName },
            exportExcel_addPercentage(segmentSet[j].SegmentValue)
          ])
        }
      }

      if (reportExcelData.length - 1 < reportExcelDataObj.length) {
        if (
          reportExcelData.length !== reportExcelDataObj.length
        ) {
          setReportExcelData(prev => [
            ...prev,
            ...reportExcelDataObj
          ])
        }
      }
    }

    loadTab1Func(resp)

    setTimeout(() => {
      updateSubLhsApiLoaded(props)
    }, 2000)
  }

  const onSuccessFunc2 = (resp) => {
    if (
      [
        'SegmentAndSegmentOfSegment',
        'SegmentAndSegmentProgression',
        'SegmentOfSegmentOverview'
      ].includes(props.InsightsElementType)
    ) {
      let pieData =
        resp?.map((d) => ({
          name: String(d.SegmentName),
          value: d.SegmentValue
        })) || []

      const barData = getObjectAsArray(
        data1[0]?.SecondarySegmentSet?.SecondarySegment || []
      )

      if (barData.length !== pieData.length) {
        // PATCH TO FIX THE COLOR CODES IF THE VALUE IS 0
        // AND ITS RESPECTIVE OBJECT IS MISSING
        const pieData2 = barData.map((d) => {
          const pData = pieData.filter(
            (f) =>
              trimFunc(f.name) === trimFunc(d.SegmentName)
          )

          return {
            name: d.SegmentName,
            value: pData?.length === 0
              ? 0
              : pData[0].value
          }
        })

        pieData = pieData2
      }

      const checkPieTotal = pieData
        .map((d) => d.value)
        .reduce((a, b) => a + b, 0)

      if (checkPieTotal < 100) {
        pieData.push({
          name: 'REMAINING_VALUE',
          value: 100 - checkPieTotal
        })
      }

      if (pieData.length > 0) {
        pieData = pieData.filter(
          f => f.value > 0
        )

        if (
          pieData.length === 1 &&
          pieData?.[0].name === 'REMAINING_VALUE'
        ) {
          pieData = []
        }
      }

      const finalExcelArray = []

      for (let j = 0; j < pieData.length; j++) {
        finalExcelArray.push([
          { value: 'Overall' },
          { value: pieData[j].name },
          exportExcel_addPercentage(pieData[j].value)
        ])
      }

      setReportExcelData(prev => [
        ...finalExcelArray,
        ...prev
      ])

      setPptData(prev => ({
        ...prev,
        pieContent: pieData
      }))

      setMaxValue(
        pieData.length > 0
          ? pieData[0].value
          : 0
      )

      /*
       * Assign the primary color here.
       *
       * The dedicated color synchronization effect will later
       * make sure the exact same color is also present as
       * `color` and `clr` inside state.
       */
      const sortedPieDataColor = [...pieData]
        .sort((a, b) => b.value - a.value)
        .map((d, i) => ({
          ...d,
          color:
            COLOR_ARRAY_NEW[i] ||
            COLOR_ARRAY_NEW[
              i % Math.max(COLOR_ARRAY_NEW.length, 1)
            ]
        }))

      setGraphPieData(sortedPieDataColor)

      setTimeout(() => {
        updateSubLhsApiLoaded(props)
      }, 2000)
    }
  }

  useEffect(() => {
    if (
      isSuccess1 &&
      !props?.serverData?.pie
    ) {
      refetch2()
    }
  }, [isSuccess1])

  useEffect(() => {
    console.log(
      'isSuccess1, data1, isSuccess2, data2',
      isSuccess1,
      data1,
      isSuccess2,
      data2
    )

    if (
      isSuccess1 &&
      data1?.length >= 0
    ) {
      onSuccessFunc1(data1)
    }

    if (
      isSuccess2 &&
      data2?.length >= 0
    ) {
      onSuccessFunc2(data2)
    }
  }, [
    isSuccess1,
    data1,
    isSuccess2,
    data2
  ])

  useEffect(() => {
    if (
      [
        'SegmentAndSegmentOfSegment'
      ].includes(props.InsightsElementType) &&
      pptData?.pieContent &&
      pptData?.tableContent
    ) {
      setFinalPptData(pptData)
    }

    if (
      [
        'SegmentAndSegmentProgression'
      ].includes(props.InsightsElementType) &&
      pptData?.pieContent &&
      pptData?.progressionContent
    ) {
      setFinalPptData(pptData)
    }

    if (
      [
        'SegmentOfSegmentOverview'
      ].includes(props.InsightsElementType) &&
      pptData?.tableContent
    ) {
      setFinalPptData(pptData)
    }
  }, [pptData])

  const titleOrderedArrayFunc = (array) => {
    orderDataByTitleFunc(array)
  }

  const orderDataByTitleFunc = (orderedTitleArray = []) => {
    /*
     * Don't reorder until we actually have an ordering array.
     *
     * The old code could call this with undefined/empty data during
     * initial render and create invalid/empty segment objects.
     */
    if (
      !Array.isArray(orderedTitleArray) ||
      orderedTitleArray.length === 0 ||
      !Array.isArray(state) ||
      state.length === 0
    ) {
      return
    }

    const data = state

    const finalData = data.map(d => {
      const tempArray = new Array(
        orderedTitleArray.length
      ).fill(null)

      for (
        let i = 0;
        i < orderedTitleArray.length;
        i++
      ) {
        const found = getObjectAsArray(
          d?.SecondarySegmentSet?.SecondarySegment
        ).find(
          s =>
            trimFunc(s.SegmentName) ===
            trimFunc(orderedTitleArray[i])
        )

        /*
         * Only add a segment when it actually exists.
         * This prevents `{ ...undefined }` from producing
         * incomplete segment objects.
         */
        tempArray[i] = found
          ? { ...found }
          : {
              SegmentName: orderedTitleArray[i],
              SegmentValue: 0,
              show: true
            }
      }

      d.SecondarySegmentSet.SecondarySegment =
        tempArray.map((c, i) => {
          const existingColor =
            c?.color ||
            c?.clr ||
            COLOR_ARRAY_NEW[i] ||
            COLOR_ARRAY_NEW[
              i % Math.max(COLOR_ARRAY_NEW.length, 1)
            ]

          return {
            ...c,
            color: existingColor,
            clr: existingColor
          }
        })

      return d
    })

    console.log('check0=6==========', finalData)

    setState(finalData)
    setTitleOrderedArray(true)
  }

  useEffect(() => {
    /*
     * Do not call orderDataByTitleFunc() with an empty array.
     *
     * The previous implementation could run before API data was
     * available and mutate state into an invalid shape.
     */
    if (
      !isTitleOrdered &&
      Array.isArray(isTitleOrdered) &&
      isTitleOrdered.length > 0
    ) {
      orderDataByTitleFunc(isTitleOrdered)
    }
  }, [isTitleOrdered])

  return (
    <>
      {(!!graphPieData?.length || !!state?.length) &&
        finalPptData && (
          <>
            <ReportHeading
              resetInsightHeight={eventCount}
              downloadId={props?.type}
              {...props}
              pptData={finalPptData}
              downloadIdData={reportExcelData}
              additionalButton={
                <GraphGridTab
                  onClick={onBtnClick}
                  show={show}
                  GraphIcon={IconGraphBtn}
                  TableIcon={IconListBtn}
                  disableActiveBg={true}
                />
              }
            />
            <PrismTopContent prismData={props.prismData} />
            <ReportOuterWrapper>
              <RootWrap id={props?.type}>
                <ContentWrap className='content'>
                  <LoaderWrapper
                    loadOnlyApi={props.loadOnlyApi}
                    isLoading={isLoading2}
                    isSuccess={isSuccess2}
                    isError={isError2}
                    error={error2}
                  >
                    {graphPieData?.length > 0 && (
                      <RelativeBrands
                        graphPieData={graphPieData}
                        showLegendToolTip={true}
                        activeTab={show}
                        maxValue={maxValue}
                        id={props?.type}
                        sortedPieColorObject={
                          sortedPieColorObject
                        }
                      />
                    )}
                  </LoaderWrapper>

                  {[
                    'SegmentAndSegmentOfSegment',
                    'SegmentOfSegmentOverview'
                  ].includes(
                    props.InsightsElementType
                  ) && (
                    <LoaderWrapper
                      loadOnlyApi={props.loadOnlyApi}
                      isLoading={isLoading1}
                      isSuccess={isSuccess1}
                      isError={isError1}
                      error={error1}
                    >
                      {!isPPTModalActive && (
                        <ProgressWrapper>
                          {checkBoxData.length > 0 && (
                            <MuiMultiSelect
                              name={checkBoxData.length}
                              placeholder={
                                `Select Category/Brand`
                              }
                              onChange={(val) =>
                                filterChangeFunc(val)
                              }
                              onSelectAll={(val) => {
                                const newVal = val
                                  ? checkBoxData
                                  : []

                                filterChangeFunc(
                                  newVal
                                )
                              }}
                              data={checkBoxData}
                              value={filterValue}
                              style={{
                                width: '24%'
                              }}
                              search={true}
                            />
                          )}

                          {/* <GraphGridTab
                            onClick={
                              onCompareBtnClick
                            }
                            show={showComparison}
                            GraphIcon={Table}
                            TableIcon={
                              IconListBtn
                            }
                            disableActiveBg={
                              true
                            }
                          /> */}
                        </ProgressWrapper>
                      )}

                      <SegmentOfSegmentWrap className='barGraph'>
                        {state &&
                          !!state.length &&
                          state?.length > 0 && (
                            <BuyerTable
                              view={
                                show
                              }
                              data={state}
                              isExtraColor={true}
                              showLegendToolTip={
                                true
                              }
                              allValuesShow={
                                allValuesShow
                              }
                              sortedPieColorObject={
                                sortedPieColorObject
                              }
                            />
                          )}
                      </SegmentOfSegmentWrap>
                    </LoaderWrapper>
                  )}

                  {[
                    'SegmentAndSegmentProgression'
                  ].includes(
                    props.InsightsElementType
                  ) && (
                    <LoaderWrapper
                      loadOnlyApi={props.loadOnlyApi}
                      isLoading={isLoading1}
                      isSuccess={isSuccess1}
                      isError={isError1}
                      error={error1}
                    >
                      {!isPPTModalActive &&
                        !!state.length && (
                          <ProgressWrapper>
                            <DropdownWrapper>
                              {checkBoxData.length >
                                0 && (
                                <MuiMultiSelect
                                  name={
                                    checkBoxData.length
                                  }
                                  placeholder={
                                    `Select Segments`
                                  }
                                  onChange={(
                                    val
                                  ) =>
                                    filterChangeFunc(
                                      val
                                    )
                                  }
                                  onSelectAll={(
                                    val
                                  ) => {
                                    const newVal =
                                      val
                                        ? checkBoxData
                                        : []

                                    filterChangeFunc(
                                      newVal
                                    )
                                  }}
                                  data={
                                    checkBoxData
                                  }
                                  value={
                                    filterValue
                                  }
                                  style={{
                                    width:
                                      '100%',
                                    maxWidth:
                                      '200px'
                                  }}
                                  search={true}
                                />
                              )}

                              {segmentData.length >
                                0 && (
                                <MuiMultiSelect
                                  name={
                                    segmentData.length
                                  }
                                  placeholder={
                                    `Select Period`
                                  }
                                  onChange={(
                                    val
                                  ) =>
                                    filterSegmentChangeFunc(
                                      val
                                    )
                                  }
                                  onSelectAll={(
                                    val
                                  ) => {
                                    const newVal =
                                      val
                                        ? segmentData
                                        : []

                                    filterSegmentChangeFunc(
                                      newVal
                                    )
                                  }}
                                  data={
                                    segmentData
                                  }
                                  value={
                                    segmentValues
                                  }
                                  style={{
                                    width:
                                      '100%',
                                    maxWidth:
                                      '200px'
                                  }}
                                  search={true}
                                />
                              )}
                            </DropdownWrapper>

                            <GraphGridTab
                              onClick={
                                onCompareBtnClick
                              }
                              show={
                                showComparison
                              }
                              GraphIcon={Table}
                              TableIcon={
                                IconListBtn
                              }
                              disableActiveBg={
                                true
                              }
                            />
                          </ProgressWrapper>
                        )}

                      {!!state.length && (
                        <ProgressionBuyerTable
                          view={showComparison}
                          isExtraColor={true}
                          data={state}
                          showLegendToolTip={true}
                          allValuesShow={
                            allValuesShow
                          }
                          insightsElementType={
                            props.InsightsElementType
                          }
                        />
                      )}
                    </LoaderWrapper>
                  )}
                </ContentWrap>
              </RootWrap>
            </ReportOuterWrapper>
          </>
        )}
    </>
  )
}

export default ReportSegmentAndSegmentOfSegmentV2
